var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-row",
        {
          attrs: {
            id: "page-focus-target"
          }
        },
        [
          _c(
            "v-col",
            [
              _c(
                "v-card",
                {
                  staticClass: "app-card card-borderless",
                  attrs: {
                    text: ""
                  }
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-stepper",
                        {
                          model: {
                            value: _vm.stepCounter,
                            callback: function callback($$v) {
                              _vm.stepCounter = $$v
                            },
                            expression: "stepCounter"
                          }
                        },
                        [
                          _c(
                            "v-stepper-header",
                            [
                              _c(
                                "v-stepper-step",
                                {
                                  attrs: {
                                    complete: _vm.stepCounter > 1,
                                    step: "1"
                                  }
                                },
                                [_vm._v("Select a Service and Domain")]
                              ),
                              _c("v-divider"),
                              _c(
                                "v-stepper-step",
                                {
                                  attrs: {
                                    complete: _vm.stepCounter > 2,
                                    step: "2"
                                  }
                                },
                                [_vm._v("Confirmation")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-stepper-items",
                            [
                              _c(
                                "v-stepper-content",
                                {
                                  attrs: {
                                    step: "1"
                                  }
                                },
                                [
                                  _c(
                                    "v-card",
                                    {
                                      staticClass: "app-card card-borderless"
                                    },
                                    [
                                      _c("v-card-text", [
                                        _c(
                                          "form",
                                          {
                                            attrs: {
                                              "data-vv-scope": "step1"
                                            }
                                          },
                                          [
                                            _c("gg-input-label", [
                                              _vm._v("Select a service")
                                            ]),
                                            _c("v-autocomplete", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'"
                                                }
                                              ],
                                              staticClass: "gg-input",
                                              attrs: {
                                                dense: "",
                                                "aria-label":
                                                  "Select a service",
                                                outlined: "",
                                                items: _vm.servicesList,
                                                name: "Service",
                                                "item-text": "domain",
                                                "item-value": "id",
                                                "return-object": "",
                                                "error-messages": _vm.errors.collect(
                                                  "step1.Service"
                                                )
                                              },
                                              on: {
                                                change: _vm.loadServiceData
                                              },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "item",
                                                  fn: function fn(_ref) {
                                                    var item = _ref.item
                                                    return [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(item.name) +
                                                          ": " +
                                                          _vm._s(item.domain) +
                                                          " "
                                                      )
                                                    ]
                                                  }
                                                }
                                              ]),
                                              model: {
                                                value: _vm.stepOne.service,
                                                callback: function callback(
                                                  $$v
                                                ) {
                                                  _vm.$set(
                                                    _vm.stepOne,
                                                    "service",
                                                    $$v
                                                  )
                                                },
                                                expression: "stepOne.service"
                                              }
                                            }),
                                            _vm.cpanelsShouldBeLoaded
                                              ? [
                                                  _c("gg-input-label", [
                                                    _vm._v("cPanel username")
                                                  ]),
                                                  _c("v-autocomplete", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: "required",
                                                        expression: "'required'"
                                                      }
                                                    ],
                                                    staticClass: "gg-input",
                                                    attrs: {
                                                      dense: "",
                                                      "aria-label":
                                                        "cPanel username",
                                                      items:
                                                        _vm.stepOne.cpanels,
                                                      loading:
                                                        _vm.stepOne
                                                          .loadingCpanels,
                                                      disabled:
                                                        _vm.stepOne
                                                          .loadingCpanels,
                                                      outlined: "",
                                                      name: "Username",
                                                      "error-messages": _vm.errors.collect(
                                                        "step1.Username"
                                                      )
                                                    },
                                                    on: {
                                                      change: _vm.loadDomains
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.stepOne
                                                          .cpanelusername,
                                                      callback: function callback(
                                                        $$v
                                                      ) {
                                                        _vm.$set(
                                                          _vm.stepOne,
                                                          "cpanelusername",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "stepOne.cpanelusername"
                                                    }
                                                  })
                                                ]
                                              : _vm._e(),
                                            _c("gg-input-label", [
                                              _vm._v("Select Domain")
                                            ]),
                                            _c("v-autocomplete", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'"
                                                }
                                              ],
                                              staticClass: "gg-input",
                                              attrs: {
                                                dense: "",
                                                outlined: "",
                                                "aria-label": "Select Domain",
                                                name: "Domain",
                                                loading:
                                                  _vm.stepOne.loadingDomains,
                                                disabled:
                                                  _vm.stepOne.loadingDomains,
                                                items: _vm.stepOne.domains,
                                                "error-messages": _vm.errors.collect(
                                                  "step1.Domain"
                                                )
                                              },
                                              model: {
                                                value: _vm.stepOne.domain,
                                                callback: function callback(
                                                  $$v
                                                ) {
                                                  _vm.$set(
                                                    _vm.stepOne,
                                                    "domain",
                                                    $$v
                                                  )
                                                },
                                                expression: "stepOne.domain"
                                              }
                                            }),
                                            _c(
                                              "gg-btn",
                                              {
                                                attrs: {
                                                  color: "primary",
                                                  tile: "",
                                                  disabled: _vm.stepOneLoading
                                                },
                                                on: {
                                                  click: function click(
                                                    $event
                                                  ) {
                                                    return _vm.moveToStep(
                                                      2,
                                                      "step1",
                                                      true
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v(" Continue ")]
                                            )
                                          ],
                                          2
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-stepper-content",
                                {
                                  attrs: {
                                    step: "2"
                                  }
                                },
                                [
                                  _c(
                                    "v-card",
                                    {
                                      staticClass: "app-card card-borderless"
                                    },
                                    [
                                      _c(
                                        "v-card-text",
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              attrs: {
                                                justify: "center"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    cols: "12",
                                                    md: "10"
                                                  }
                                                },
                                                [
                                                  _c("v-data-table", {
                                                    attrs: {
                                                      "hide-default-header": "",
                                                      "hide-default-footer": "",
                                                      headers:
                                                        _vm.providersHeaders,
                                                      items: _vm.stepThree.items
                                                    },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "header",
                                                        fn: function fn(_ref2) {
                                                          var headers =
                                                            _ref2.props.headers
                                                          return [
                                                            _c("thead", [
                                                              _c(
                                                                "tr",
                                                                _vm._l(
                                                                  headers,
                                                                  function(
                                                                    header
                                                                  ) {
                                                                    return _c(
                                                                      "th",
                                                                      {
                                                                        key:
                                                                          header.text,
                                                                        staticClass:
                                                                          "text-center pa-4"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              header.text
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                        header.chip
                                                                          ? _c(
                                                                              "br"
                                                                            )
                                                                          : _vm._e(),
                                                                        header.chip
                                                                          ? _c(
                                                                              "v-chip",
                                                                              {
                                                                                attrs: {
                                                                                  color:
                                                                                    header
                                                                                      .chip
                                                                                      .color,
                                                                                  dark:
                                                                                    "",
                                                                                  "x-small":
                                                                                    ""
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      header
                                                                                        .chip
                                                                                        .text
                                                                                    ) +
                                                                                    " "
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                        _c("br")
                                                                      ],
                                                                      1
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              )
                                                            ])
                                                          ]
                                                        }
                                                      },
                                                      {
                                                        key: "body",
                                                        fn: function fn(_ref3) {
                                                          var items =
                                                            _ref3.items
                                                          return [
                                                            _c(
                                                              "tbody",
                                                              _vm._l(
                                                                items,
                                                                function(item) {
                                                                  return _c(
                                                                    "tr",
                                                                    {
                                                                      key:
                                                                        item.name,
                                                                      staticClass:
                                                                        "text-center"
                                                                    },
                                                                    [
                                                                      _c("td", [
                                                                        _c(
                                                                          "b",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                item
                                                                                  .feature
                                                                                  .text
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]),
                                                                      _c("td", [
                                                                        item
                                                                          .alphassl
                                                                          .icon
                                                                          ? _c(
                                                                              "div",
                                                                              [
                                                                                item
                                                                                  .alphassl
                                                                                  .icon
                                                                                  .withText
                                                                                  ? _c(
                                                                                      "div",
                                                                                      [
                                                                                        _c(
                                                                                          "v-icon",
                                                                                          {
                                                                                            attrs: {
                                                                                              color:
                                                                                                item
                                                                                                  .alphassl
                                                                                                  .icon
                                                                                                  .color
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              " " +
                                                                                                _vm._s(
                                                                                                  item
                                                                                                    .alphassl
                                                                                                    .icon
                                                                                                    .name
                                                                                                ) +
                                                                                                " "
                                                                                            )
                                                                                          ]
                                                                                        ),
                                                                                        _c(
                                                                                          "br"
                                                                                        ),
                                                                                        _vm._v(
                                                                                          " " +
                                                                                            _vm._s(
                                                                                              item
                                                                                                .alphassl
                                                                                                .text
                                                                                            ) +
                                                                                            " "
                                                                                        )
                                                                                      ],
                                                                                      1
                                                                                    )
                                                                                  : _c(
                                                                                      "div",
                                                                                      [
                                                                                        _c(
                                                                                          "v-icon",
                                                                                          {
                                                                                            attrs: {
                                                                                              color:
                                                                                                item
                                                                                                  .alphassl
                                                                                                  .icon
                                                                                                  .color
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              " " +
                                                                                                _vm._s(
                                                                                                  item
                                                                                                    .alphassl
                                                                                                    .icon
                                                                                                    .name
                                                                                                ) +
                                                                                                " "
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      ],
                                                                                      1
                                                                                    )
                                                                              ]
                                                                            )
                                                                          : _c(
                                                                              "span",
                                                                              {
                                                                                domProps: {
                                                                                  innerHTML: _vm._s(
                                                                                    item
                                                                                      .alphassl
                                                                                      .text
                                                                                  )
                                                                                }
                                                                              }
                                                                            )
                                                                      ]),
                                                                      _c(
                                                                        "td",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "show",
                                                                              rawName:
                                                                                "v-show",
                                                                              value:
                                                                                _vm.leEnabled,
                                                                              expression:
                                                                                "leEnabled"
                                                                            }
                                                                          ]
                                                                        },
                                                                        [
                                                                          item
                                                                            .le
                                                                            .icon
                                                                            ? _c(
                                                                                "span",
                                                                                [
                                                                                  item
                                                                                    .le
                                                                                    .icon
                                                                                    .withText
                                                                                    ? _c(
                                                                                        "span",
                                                                                        [
                                                                                          _c(
                                                                                            "v-icon",
                                                                                            {
                                                                                              attrs: {
                                                                                                color:
                                                                                                  item
                                                                                                    .le
                                                                                                    .icon
                                                                                                    .color
                                                                                              }
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " " +
                                                                                                  _vm._s(
                                                                                                    item
                                                                                                      .le
                                                                                                      .icon
                                                                                                      .name
                                                                                                  ) +
                                                                                                  " "
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _c(
                                                                                            "br"
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " " +
                                                                                              _vm._s(
                                                                                                item
                                                                                                  .le
                                                                                                  .text
                                                                                              ) +
                                                                                              " "
                                                                                          )
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                    : _c(
                                                                                        "span",
                                                                                        [
                                                                                          _c(
                                                                                            "v-icon",
                                                                                            {
                                                                                              attrs: {
                                                                                                color:
                                                                                                  item
                                                                                                    .le
                                                                                                    .icon
                                                                                                    .color
                                                                                              }
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " " +
                                                                                                  _vm._s(
                                                                                                    item
                                                                                                      .le
                                                                                                      .icon
                                                                                                      .name
                                                                                                  ) +
                                                                                                  " "
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                ]
                                                                              )
                                                                            : _c(
                                                                                "span",
                                                                                [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        item
                                                                                          .le
                                                                                          .text
                                                                                      ) +
                                                                                      " "
                                                                                  )
                                                                                ]
                                                                              ),
                                                                          item
                                                                            .le
                                                                            .hint
                                                                            ? _c(
                                                                                "v-tooltip",
                                                                                {
                                                                                  attrs: {
                                                                                    "max-width":
                                                                                      "400",
                                                                                    bottom:
                                                                                      ""
                                                                                  },
                                                                                  scopedSlots: _vm._u(
                                                                                    [
                                                                                      {
                                                                                        key:
                                                                                          "activator",
                                                                                        fn: function fn(
                                                                                          _ref4
                                                                                        ) {
                                                                                          var on =
                                                                                            _ref4.on
                                                                                          return [
                                                                                            _c(
                                                                                              "v-icon",
                                                                                              _vm._g(
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "mb-1",
                                                                                                  attrs: {
                                                                                                    small:
                                                                                                      ""
                                                                                                  }
                                                                                                },
                                                                                                on
                                                                                              ),
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "mdi-information-outline"
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          ]
                                                                                        }
                                                                                      }
                                                                                    ],
                                                                                    null,
                                                                                    true
                                                                                  )
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "span",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          item
                                                                                            .le
                                                                                            .hint
                                                                                        )
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              )
                                                                            : _vm._e()
                                                                        ],
                                                                        1
                                                                      )
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ])
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass:
                                                    "hidden-sm-and-up",
                                                  attrs: {
                                                    cols: "12"
                                                  }
                                                },
                                                [
                                                  _vm.leEnabled
                                                    ? _c(
                                                        "gg-btn",
                                                        {
                                                          staticClass: "mb-2",
                                                          attrs: {
                                                            color: "primary",
                                                            tile: ""
                                                          },
                                                          on: {
                                                            click: function click(
                                                              $event
                                                            ) {
                                                              return _vm.selectProvider(
                                                                1
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Select Let's Encrypt "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "gg-btn",
                                                    {
                                                      attrs: {
                                                        color: "primary",
                                                        tile: ""
                                                      },
                                                      on: {
                                                        click: function click(
                                                          $event
                                                        ) {
                                                          return _vm.selectProvider(
                                                            0
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("Buy AlphaSSL")]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-card",
                                    {
                                      staticClass: "app-card card-borderless"
                                    },
                                    [
                                      _c(
                                        "v-card-text",
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "ma-2"
                                            },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    cols: "12"
                                                  }
                                                },
                                                [_c("hr")]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    cols: "12"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "h1",
                                                    {
                                                      staticClass: "mb-4"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Payment Information"
                                                      )
                                                    ]
                                                  ),
                                                  _c("p", [
                                                    _vm._v(
                                                      "Please, recheck your selections before submission."
                                                    )
                                                  ]),
                                                  _c(
                                                    "v-alert",
                                                    {
                                                      staticClass: "py-2 mb-4",
                                                      attrs: {
                                                        type: "warning",
                                                        color: "primary",
                                                        tabindex: "0",
                                                        role: "note",
                                                        value:
                                                          _vm.stepThree
                                                            .provider === 0
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "align-center"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " You will be charged $49.95 for 1 year, then $99.95/year. "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-alert",
                                                    {
                                                      staticClass: "py-2 mb-4",
                                                      attrs: {
                                                        type: "warning",
                                                        color: "primary",
                                                        role: "note",
                                                        value:
                                                          _vm.stepThree
                                                            .provider === 1
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "align-center"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Read about the "
                                                          ),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticStyle: {
                                                                color: "white",
                                                                "font-weight":
                                                                  "bold"
                                                              },
                                                              attrs: {
                                                                target:
                                                                  "_blank",
                                                                href:
                                                                  "https://www.greengeeks.com/support/article/lets-encrypt-installation-process/"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Let's Encrypt Installation Process "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            " to confirm your domain is ready. "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-form",
                                            {
                                              attrs: {
                                                "data-vv-scope": "step3"
                                              }
                                            },
                                            [
                                              _c("gg-input-label", [
                                                _vm._v("Selected Domain")
                                              ]),
                                              _c("v-combobox", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                attrs: {
                                                  dense: "",
                                                  outlined: "",
                                                  name: "Domain",
                                                  "aria-label":
                                                    "Selected Domain",
                                                  disabled: "",
                                                  items: _vm.stepOne.domains,
                                                  "error-messages": _vm.errors.collect(
                                                    "step4.Domain"
                                                  )
                                                },
                                                model: {
                                                  value: _vm.stepOne.domain,
                                                  callback: function callback(
                                                    $$v
                                                  ) {
                                                    _vm.$set(
                                                      _vm.stepOne,
                                                      "domain",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "stepOne.domain"
                                                }
                                              }),
                                              _vm.cpanelsShouldBeLoaded
                                                ? [
                                                    _c("gg-input-label", [
                                                      _vm._v("cPanel Username")
                                                    ]),
                                                    _c("v-combobox", {
                                                      directives: [
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: "required",
                                                          expression:
                                                            "'required'"
                                                        }
                                                      ],
                                                      staticClass: "gg-input",
                                                      attrs: {
                                                        dense: "",
                                                        "aria-label":
                                                          "cPanel Username",
                                                        items:
                                                          _vm.stepOne.cpanels,
                                                        loading:
                                                          _vm.stepOne
                                                            .loadingCpanels,
                                                        disabled: "",
                                                        outlined: "",
                                                        name: "Username",
                                                        "error-messages": _vm.errors.collect(
                                                          "step1.Username"
                                                        )
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.stepOne
                                                            .cpanelusername,
                                                        callback: function callback(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.stepOne,
                                                            "cpanelusername",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "stepOne.cpanelusername"
                                                      }
                                                    })
                                                  ]
                                                : _vm._e(),
                                              _c("gg-input-label", [
                                                _vm._v("SSL Provider")
                                              ]),
                                              _c("v-select", {
                                                staticClass: "gg-input",
                                                attrs: {
                                                  dense: "",
                                                  outlined: "",
                                                  "aria-label": "SSL Provider",
                                                  disabled: "",
                                                  "item-text": "text",
                                                  "item-value": "value",
                                                  items: _vm.providersList
                                                },
                                                model: {
                                                  value: _vm.stepThree.provider,
                                                  callback: function callback(
                                                    $$v
                                                  ) {
                                                    _vm.$set(
                                                      _vm.stepThree,
                                                      "provider",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "stepThree.provider"
                                                }
                                              }),
                                              _vm.alphaSslSelected
                                                ? [
                                                    !_vm.isAssignedAccessService
                                                      ? _c(
                                                          "certificate-payment",
                                                          {
                                                            ref: "cardForm"
                                                          }
                                                        )
                                                      : _vm._e(),
                                                    _c("p", [
                                                      _vm._v(
                                                        " Your order will be reviewed and processed by our Sales team. You will receive an order confirmation number on the next page. "
                                                      )
                                                    ]),
                                                    _vm.isAssignedAccessService
                                                      ? _c(
                                                          "v-alert",
                                                          {
                                                            staticClass: "py-2",
                                                            attrs: {
                                                              type: "error",
                                                              icon: "mdi-alert"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              " You are placing an order for a service you are assigned access to. The account owner will be billed for this SSL certificate. "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                : _vm._e(),
                                              _c(
                                                "gg-btn",
                                                {
                                                  staticClass: "mr-2",
                                                  attrs: {
                                                    color: "primary",
                                                    tile: "",
                                                    loading: _vm.loading
                                                  },
                                                  on: {
                                                    click: _vm.submitForm
                                                  }
                                                },
                                                [_vm._v(" Confirm and Create ")]
                                              ),
                                              _c(
                                                "gg-btn",
                                                {
                                                  attrs: {
                                                    secondary: "",
                                                    depressed: "",
                                                    tile: ""
                                                  },
                                                  on: {
                                                    click: _vm.goBack
                                                  }
                                                },
                                                [_vm._v("Cancel Upgrade")]
                                              )
                                            ],
                                            2
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-stepper-content",
                                {
                                  attrs: {
                                    step: "3"
                                  }
                                },
                                [
                                  _c(
                                    "v-card",
                                    [
                                      _vm.stepFour.error
                                        ? [
                                            _c(
                                              "v-card-title",
                                              {
                                                staticClass:
                                                  "app-card-title pb-0"
                                              },
                                              [
                                                _c("h3", [
                                                  _vm._v("Error Adding New SSL")
                                                ])
                                              ]
                                            ),
                                            _c("v-card-text", [
                                              _c("p", [
                                                _vm._v(
                                                  " There was an error with your request. Please try again later or contact Support. "
                                                )
                                              ])
                                            ])
                                          ]
                                        : _vm._e(),
                                      !!_vm.stepFour.order_id
                                        ? [
                                            _c(
                                              "v-card-title",
                                              {
                                                staticClass:
                                                  "app-card-title pb-0 mb-3"
                                              },
                                              [
                                                _c("h3", [
                                                  _vm._v(
                                                    "SSL Certificate Order Received"
                                                  )
                                                ])
                                              ]
                                            ),
                                            _c("v-card-text", [
                                              _c("p", [
                                                _vm._v(
                                                  "Thank you! Your SSL certificate order has been received and will be processed shortly."
                                                )
                                              ]),
                                              _c("p", [
                                                _vm._v("Your order number is "),
                                                _c("b", [
                                                  _vm._v(
                                                    "#" +
                                                      _vm._s(
                                                        _vm.stepFour.order_id
                                                      )
                                                  )
                                                ])
                                              ])
                                            ])
                                          ]
                                        : !!_vm.stepFour.ssl_id
                                        ? [
                                            _c(
                                              "v-card-title",
                                              {
                                                staticClass:
                                                  "app-card-title pb-0"
                                              },
                                              [
                                                _c("h3", [
                                                  _vm._v(
                                                    "Let's Encrypt SSL Request Received"
                                                  )
                                                ])
                                              ]
                                            ),
                                            _c("v-card-text", [
                                              _c("p", [
                                                _vm._v(
                                                  " Thank you! Your Let's Encrypt SSL request has been received and will be processed shortly. "
                                                )
                                              ])
                                            ])
                                          ]
                                        : _vm._e(),
                                      _c(
                                        "v-card-actions",
                                        [
                                          _c(
                                            "gg-btn",
                                            {
                                              attrs: {
                                                to: {
                                                  name: "ssl_list"
                                                },
                                                tile: ""
                                              }
                                            },
                                            [_vm._v("View Certificates")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("gg-modal", {
        attrs: {
          "is-active": _vm.stepOne.errorModal
        },
        scopedSlots: _vm._u([
          {
            key: "toolbar",
            fn: function fn() {
              return [_vm._v(" Domain Not Allowed ")]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function fn() {
              return [
                _vm._v(
                  " We are not able to issue an AlphaSSL certificate for this domain's TLD. Please contact us if you have any questions. "
                )
              ]
            },
            proxy: true
          },
          {
            key: "actions",
            fn: function fn() {
              return [
                _c(
                  "gg-btn",
                  {
                    on: {
                      click: _vm.triggerErrorModal
                    }
                  },
                  [_vm._v("Close")]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }